export const isOrderStrategic = (orderNumber: string) => {
    return orderNumber.startsWith('ON');
}
